import {Component, Input} from '@angular/core';
import {NavParams} from "ionic-angular";
import moment from "moment";

/**
 * Generated class for the AdvertComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'flip-clock',
    templateUrl: 'flip-clock.html'
})
export class FlipClockComponent {

    @Input() minutes;

    days: any;
    hours: any;
    mins: any;
    isOverrunning: boolean = false;

    cachedTime: any = {
      days: '00',
      hours: '00',
      minutes: '00',
      previous_days: null,
      previous_hours: null,
      previous_minutes: null,
    };

    constructor() {

    }

    ngOnChanges(){
      this.checkIsOverRunning();
      this.getTimeFromMinutes(Math.abs(this.minutes));
      this.flipClock();
    }

    checkIsOverRunning(){
      if (this.minutes<0){
        this.isOverrunning = true;
      } else {
        this.isOverrunning = false;
      }
    }

    getTimeFromMinutes(mins){
      mins = parseInt(mins);
      let now = moment();
      let exp = moment().add(mins, 'minutes');
      let diffDuration = moment.duration(exp.diff(now));
      let days = diffDuration.days();
      let hours = diffDuration.hours();
      let minutes = diffDuration.minutes();
      let secounds = diffDuration.seconds();
      secounds > 30 ? minutes = minutes + 1 : null;

      this.days =  (days ? ( days < 10 ? '0' + days : days ) : '00');
      this.hours =  (hours ? ( hours < 10 ? '0' + hours : hours ) : '00');
      this.mins =  (minutes ? ( minutes < 10 ? '0' + minutes : minutes ) : '00');

      this.cachedTime = {
        days: this.days,
        hours: this.hours,
        minutes: this.mins,
        previous_days: this.cachedTime.days,
        previous_hours: this.cachedTime.hours,
        previous_minutes: this.cachedTime.minutes,
      };

    }

    flipMinutes(){
      var element = document.getElementById('flip-clock__minutes');
      if (element) {
        element.classList.add('flip');
        setTimeout(_ => {
          element.classList.remove('flip');
        }, 950);
      }
    }

    flipHours(){
      var element = document.getElementById('flip-clock__hours');
      if (element) {
        element.classList.add('flip');
        setTimeout(_ => {
          element.classList.remove('flip');
        }, 950);
      }
    }

    flipClock(){

      if (this.cachedTime.minutes !== this.cachedTime.previous_minutes){
        this.flipMinutes();
      }

      if (this.cachedTime.hours !== this.cachedTime.previous_hours){
        this.flipHours();
      }

    }

}



// WEBPACK FOOTER //
// ./src/components/flip-clock/flip-clock.ts